module.exports = __webpack_public_path__ + "img/img-ruleSet-example2.c264d1ae.png";